// extracted by mini-css-extract-plugin
export default {"scroll-top-btn":"App_scroll-top-btn__1C71B","hide-scroll-top-btn":"App_hide-scroll-top-btn__8uCGJ"};